import { observable, action, decorate, toJS } from 'mobx';
// import _ from 'lodash';
import { toast } from 'utils/helpers';
import { history } from 'utils/history';
import {
  getOne,
  create,
  update,
} from 'services/servicePackages';

class Store {
  record = null

  // Action
  reset = () => {
    this.record = null;
  }

  // Action
  setRecord = record => {
    this.record = record;
  }

  getOne = async (id) => {
    const data = await getOne(id);

    this.setRecord(data);
  }

  create = async () => {
    const record = toJS(this.record);

    try {
      await create(record);
      toast('Įrašas sukurtas', 'success');
      history.push('/service-packages');
    } catch (err) {
      toast('Nepavyko išsaugoti', 'danger');
    }
  }

  update = async () => {
    const record = toJS(this.record);
    
    try {
      await update(record._id, record);
      toast('Įrašas atnaujintas', 'success');
      history.push('/service-packages');
    } catch (err) {
      toast('Nepavyko išsaugoti', 'danger');
    }
  }
}

decorate(Store, {
  record: observable,
  setRecord: action,
  reset: action,
});

export default new Store;